<template>
    <div v-if="event" class="competence-item">
        <v-icon size="14" color="accent" class="competence-icon">mdi-trophy-variant</v-icon>
        <div class="competence-name">{{ event.event.versus }}</div>
        <div class="competence-label">{{ $t('common.competence') }}</div>
        <div class="competence-actions">
            <button-tooltip @click="$emit('click:show')" icon x-small color="txtSecondary"
                :tooltip="$t('tooltips.edit_competence')" :disabled="dragging">
                <v-icon size="15">$edit</v-icon>
            </button-tooltip>
            <button-tooltip @click="$emit('click:delete')" icon x-small color="error"
                :tooltip="$t('tooltips.delete_competence')" :disabled="dragging">
                <v-icon size="15">mdi-delete</v-icon>
            </button-tooltip>
        </div>
    </div>
</template>

<script>
import ButtonTooltip from "@/components/common/ButtonTooltip";
export default {
    name: "CompetenceEvent",
    components: { ButtonTooltip },
    props: {
        event: {
            type: Object,
            default: null,
        },
        dragging: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.competence-item {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 100%;
    min-height: 22px;
    position: relative;
    padding: 0 8px 0 6px;
    border-radius: 4px;
    cursor: grab;
    user-select: none;
}

.competence-item:hover {
    background: var(--v-surface2-base);
}

.competence-icon {
    flex-shrink: 0;
}

.competence-name {
    font-size: 11px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
}

.competence-label {
    font-size: 10px;
    font-weight: 400;
    color: var(--v-txtMuted-base);
    white-space: nowrap;
    flex-shrink: 0;
    transition: opacity .12s;
}

.competence-item:hover .competence-label {
    opacity: 0;
}

.competence-actions {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: 2px;
    opacity: 0;
    transition: opacity .12s;
    pointer-events: none;
    background: var(--v-surface2-base);
    padding-left: 6px;
    border-radius: 4px;
}

.competence-item:hover .competence-actions {
    opacity: 1;
    pointer-events: all;
}
</style>
